//
//
//
//
//
//
//

import iconFacebook from '@/assets/icon/itemDetail/gift_share_ic_facebook_normal@2x.png'
import configApi from '@/store/apis/config'
import { getStaticShareUrl } from '@/tools/ObjectHelper'
import configs from '@/tools/configs'

window.fbAsyncInit = () => {
  /* eslint-disable */
  FB.init({
    appId: configs.facebookAppID,
    cookie: true,
    xfbml: true,
    version: 'v6.0'
  })
  /* eslint-disable */
}

(function (d, s, id) {
  let js
  const fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/zh_TW/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
}(document, 'script', 'facebook-jssdk'))

export default {
  data () {
    return {
      iconFacebook
    }
  },
  props: {
    showWord: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    desc: {
      type: String
    },
    image: {
      type: String
    },
    shareSuc: {
      type: Function
    },
    url: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: Number,
      default: 66
    },
    objectId: {
      type: Number
    },
    query: {
      type: String,
      default: ''
    }
  },
  created () {
    // this.initShareImage()
  },
  methods: {
    share () {
      this.$ga.trackEvent('fb_share', 'share', this.url)

      if (this.type === 'sponsor' || this.type === 'url') {
        this.fbshare(this.url)
        return
      }

      const shareUrl = getStaticShareUrl(this.type, this.objectId, this.query)
      if (shareUrl) {
        this.fbshare(shareUrl)
        return
      }

      configApi.getShareUrl(
        {
          title: this.title,
          description: this.desc,
          image: this.image,
          url: this.url,
        },
        data => {
          if (data && data.id) {
            let href = `${configs.frontEndUrl}share/${data.id}`
            console.log(href, '分享链接 href')
            this.fbshare(href, this.title)
          }
        }
      )
    },
    fbshare (href, title = '') {
      /* eslint-disable */
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${href}&title=${title}`, '_blank')
      this.shareSuc && this.shareSuc()
      // FB.ui({
      //   method: 'share',
      //   href
      // }, (response) => {
      //   if (response && response.constructor === Array) {
      //     this.shareSuc && this.shareSuc()
      //   } else {
      //     this.$vux.toast.text('分享失敗,請稍後重試', 'bottom')
      //   }
      //   console.log(response)
      // })
      /* eslint-disable */
    }
  }
}
